import { API_SERVER } from 'config/constant';
import { urls } from 'utils/url/urls';

const person = localStorage.getItem('user');
const user = JSON.parse(person);
export async function adminLogin(data) {
  try {
    const response = await fetch(`${API_SERVER}${urls.adminLogin}`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    });
    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
}
export async function logoutAuto(data) {
  try {
    const response = await fetch(`${API_SERVER}${urls.logoutAuto}`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: user?.token,
      },
      body: data,
    });
    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
}
// export async function validityLogin(validityData) {
//   const token = localStorage.getItem('userToken');
//   try {
//     const response = await fetch(`${API_SERVER}${urls.validityLogin}`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${token}`,
//       },
//       body: JSON.stringify(validityData),
//     });

//     const result = await response.json();
//     return result;
//   } catch (err) {
//     console.error('Error in validityLogin:', err);
//     throw err;
//   }
// }
export async function validityLogin(validityData) {

  const token = localStorage.getItem('token');

  try {

    const headers = {
      'Content-Type': 'application/json',
    };

    // Add Authorization only if token exists
    if (token && token !== "null" && token !== "undefined") {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(
      `${API_SERVER}${urls.validityLogin}`,
      {
        method: 'POST',
        headers,
        body: JSON.stringify(validityData),
      }
    );

    const result = await response.json();

    return result;

  } catch (err) {

    console.error('Error in validityLogin:', err);
    throw err;

  }
}